import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04ed7fdc")

_pushScopeId("data-v-04ed7fdc")
const _hoisted_1 = { class: "simple" }
const _hoisted_2 = {
  key: 0,
  class: "p-float-label"
}
const _hoisted_3 = {
  key: 1,
  class: "p-float-label"
}
const _hoisted_4 = {
  key: 2,
  class: "p-float-label"
}
const _hoisted_5 = {
  key: 3,
  class: "p-float-label"
}
const _hoisted_6 = {
  key: 4,
  class: "p-float-label"
}
const _hoisted_7 = {
  key: 5,
  class: "p-float-label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Textarea = _resolveComponent("Textarea")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localTransformation.parameters, (field, index) => {
      return (_openBlock(), _createBlock("span", {
        key: index,
        class: "p-field p-ml-2 kn-flex data-prep-simple-transformation"
      }, [
        (field.type == 'string')
          ? (_openBlock(), _createBlock("span", _hoisted_2, [
              _createVNode(_component_InputText, {
                id: field.id,
                type: "text",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                disabled: _ctx.readOnly,
                class: ['kn-material-input', field.validationRules && field.validationRules.includes('required') && !field.value ? 'p-invalid' : '']
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "class"]),
              _createVNode("label", {
                for: 'input_index_' + index,
                class: "kn-material-input-label"
              }, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.' + field.name)), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (field.type === 'date')
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _createVNode(_component_Calendar, {
                id: field.id,
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                disabled: _ctx.readOnly,
                class: ["kn-material-input", { 'p-invalid': field.validationRules && field.validationRules.includes('required') && !field.value }]
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "class"]),
              _createVNode("label", {
                for: field.type + '_index_' + index,
                class: "kn-material-input-label"
              }, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.' + field.name)), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (field.type === 'boolean')
          ? (_openBlock(), _createBlock("span", _hoisted_4, [
              _createVNode(_component_InputSwitch, {
                id: field.id,
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                disabled: _ctx.readOnly
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", {
                for: 'inputSwitch_index_' + index,
                class: "kn-material-input-label"
              }, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.' + field.name)), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (field.type === 'dropdown')
          ? (_openBlock(), _createBlock("span", _hoisted_5, [
              _createVNode(_component_Dropdown, {
                id: field.id,
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                options: field.availableOptions ? _ctx.translate(field) : _ctx.columns,
                showClear: !field.validationRules || (field.validationRules && !field.validationRules.includes('required')),
                optionLabel: field.optionLabel ? field.optionLabel : 'label',
                optionValue: field.optionValue ? field.optionValue : 'code',
                disabled: (_ctx.col && field.name === 'columns') || _ctx.readOnly,
                class: ["kn-material-input", { 'p-invalid': field.validationRules && field.validationRules.includes('required') && !field.value }]
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options", "showClear", "optionLabel", "optionValue", "disabled", "class"]),
              _createVNode("label", {
                for: 'selectedCondition_index_' + index,
                class: "kn-material-input-label"
              }, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.' + field.name)), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (field.type == 'multiSelect')
          ? (_openBlock(), _createBlock("span", _hoisted_6, [
              _createVNode(_component_MultiSelect, {
                id: field.id,
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                options: _ctx.columns,
                optionLabel: field.optionLabel ? field.optionLabel : 'label',
                display: "chip",
                optionDisabled: "disabled",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMultiSelectChange($event))),
                "allow-empty": false,
                disabled: _ctx.col || _ctx.readOnly,
                class: ["kn-material-input", { 'p-invalid': field.validationRules && field.validationRules.includes('required') && !field.value }],
                filter: true
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options", "optionLabel", "disabled", "class"]),
              _createVNode("label", {
                for: 'selectedItems_index_' + index,
                class: "kn-material-input-label"
              }, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.columns')), 9, ["for"])
            ]))
          : _createCommentVNode("", true),
        (field.type == 'textarea')
          ? (_openBlock(), _createBlock("span", _hoisted_7, [
              _createVNode(_component_Textarea, {
                id: field.id,
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event),
                disabled: _ctx.readOnly,
                rows: "5",
                cols: "30",
                class: ["kn-material-input", { 'p-invalid': field.validationRules && field.validationRules.includes('required') && !field.value }],
                autoResize: false
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "class"]),
              _createVNode("label", {
                for: field.type + '_index_' + index,
                class: "kn-material-input-label"
              }, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.' + field.name)), 9, ["for"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
})